<script>
import { Doughnut, mixins } from 'vue-chartjs';

const noDataPlugin = {
  id: 'noDataAvailable',
  afterDraw(chart) {
    const datasets = chart.data.datasets;
    if (datasets.length === 0 || datasets[0].data.reduce((carry, value) => carry + value, 0) === 0) {
      // No data is present
      const ctx = chart.chart.ctx;
      const width = chart.chart.width;
      const height = chart.chart.height;
      chart.clear();

      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = "16px normal 'Helvetica Nueue'";
      ctx.fillStyle = 'blue';
      ctx.fillText('No data to display', width / 2, height / 2);
      ctx.restore();
    }
  }
};

export default {
  name: 'DoughnutChart',
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: Object,
    options: {
      type: Object,
      default: () => ({
        legend: {
          position: 'bottom'
        }
      })
    }
  },

  mounted() {
    this.addPlugin(noDataPlugin);
    this.renderChart(this.chartData, this.options);
  }
};
</script>
